export default {
  title: 'Protocole',
  subtitle: 'Informations du protocole',
  assign: 'Assigner à un service',
  creationDate: 'Créé le '
}
